import { AfterViewInit, Component, EventEmitter, Output, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseUI } from '../../base.ui';
import { Document, FullClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { SourceFunds } from '../../../../core';

@Component({
    selector: 'thr-full-data-eight-natural-person',
    templateUrl: './full-data-eight-natural-person.component.html',
    styleUrls: ['./full-data-eight-natural-person.component.scss'],
})
export class FullDataEightNaturalPersonComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy {
    public SourceFunds: typeof SourceFunds = SourceFunds;

    public form: NgForm;
    public isFormValid = false;

    public save = false;
    public investment = false;
    public transactions = false;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Input()
    isDisabledSubmit = false;

    @Output()
    documentView: EventEmitter<Document> = new EventEmitter();

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get maxSize(): number {
        return 25 * 1024 * 1024;
    }

    get allowedTypes(): string[] {
        return [
            'image/jpeg',
            'image/jpg',
            'image/png',
            'application/pdf',
            'application/zip',
            'application/octet-stream',
            'application/x-zip-compressed',
            'multipart/x-zip',
        ];
    }

    get allowedExtension(): string[] {
        return ['.jpeg', '.jpg', '.png', '.pdf', '.zip'];
        }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onDocumentView(document: Document) {
        if (document.id) {
            this.documentView.emit(document);
        }
    }

    onDocumentRemove(document: Document) {
        if (document.id) {
            document.remove = true;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('client' in changes && !!this.client) {
            this.save = String(this.client.professional.purposeKYC)?.indexOf('1') !== -1;
            this.investment = String(this.client.professional.purposeKYC)?.indexOf('2') !== -1;
            this.transactions = String(this.client.professional.purposeKYC)?.indexOf('3') !== -1;
        }
    }

    onChangePurpose(purpose: string) {
        setTimeout(() => {
            switch (purpose) {
                case 'save':
                    this.save = !this.save;
                    break;
                case 'investment':
                    this.investment = !this.investment;
                    break;
                default:
                    this.transactions = !this.transactions;
            }

            this.client.professional.purposeKYC = Number(
                (this.save ? '1' : '') + (this.investment ? '2' : '') + (this.transactions ? '3' : '')
            );
        });
    }
}
